import { Box, LinearProgress } from '@mui/material';
import React, { useEffect, useState, memo } from 'react';
import ItemApi from 'src/api/ItemApi';
import { Logger } from 'src/utils/logger';

export type CustomerPriceProps = {
  itemNumber: string;
  quantity: number;
  defaultPrice: number;
  load: boolean;
  customerNumber: string;
  warehouseCode: string;
  shipToNumber: string;
  children?: React.ReactNode;
};

const CustomerPrice: React.FC<React.PropsWithChildren<CustomerPriceProps>> = ({ itemNumber, quantity, defaultPrice, load, customerNumber, warehouseCode, shipToNumber }) => {
  const [loading, setLoading] = useState(true);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    if (load && price === 0) {
      setLoading(true);
      ItemApi.getCustomerPrice(itemNumber, customerNumber, warehouseCode, quantity, defaultPrice, shipToNumber)
        .then((customerPrice) => {
          setPrice(customerPrice);
        })
        .catch((e) => {
          Logger.error(e);
          setPrice(0);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [itemNumber]);

  return (
    <Box className="customer-price">
      {loading && <LinearProgress />}
      {!loading && <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)}</span>}
    </Box>
  );
};

export default memo(CustomerPrice);
